import PasswordResetForm from '../../components/passwords/PasswordResetForm';
import './LoginPortal.scss';

const PasswordResetPortal = (props) => (
  <PasswordResetForm {...props} />
);

export default PasswordResetPortal;
